export default {
  name: 'account--company',
  apiService: 'account',
  apiPath: '/admin/company',
};